document.addEventListener("DOMContentLoaded", function () {
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

    if ("IntersectionObserver" in window) {
        var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
                if (video.isIntersecting) {
                    for (var source in video.target.children) {
                        var videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }

                    video.target.load();
                    video.target.classList.remove("lazy");
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });

        lazyVideos.forEach(function (lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });
    }
});

(function ($, win) {
    $.fn.inViewport = function (cb) {
        return this.each(function (i, el) {
            function visPx() {
                var H = $(this).height(),
                    r = el.getBoundingClientRect(),
                    t = r.top,
                    b = r.bottom;
                return cb.call(el, Math.max(0, t > 0 ? H - t : (b < H ? b : H)));
            }
            visPx();
            $(win).on("resize scroll", visPx);
        });
    };
}(jQuery, window));

var debounce = function (func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        if (immediate && !timeout) func.apply(context, args);
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

/* (function () {
    'use strict';
    window.addEventListener('load', function () {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function (form) {

            form.addEventListener('submit', function (event) {
                // Stop propagating the form if contains invalid elements
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');

                // Loop invalid elements and add invalid feedback text
                for (var i = 0; i < form.elements.length; i++) {
                    // If form element is invalid, update feedback text
                    var currFormElement = form.elements[i];

                    if (!currFormElement.checkValidity()) {
                        jQuery('.invalid-feedback', jQuery(currFormElement).parent())
                            .text(currFormElement.validationMessage);
                    }
                }
            }, false);
        });
    }, false);
})(); */

var ACTDIG = ACTDIG || (ACTDIG = {});
ACTDIG.Funcs = (function ($, window, document) {
    $.urlParam = function (name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        return results[1] || 0;
    };

    /**
     * Move the owl prev/next inline with owl-dots
     */
    function owl() {

        $('.owl-carousel').each(function () {
            var $self = $(this);

            if ($self.hasClass('owl-nav-float')) {
                return;
            }

            if ($self.find('.owl-newnav').length == 0) {
                $self.find('.owl-dots')
                    .wrap('<div class="owl-newnav"></div>');

                $self.find('.owl-nav')
                    .find('.owl-prev')
                    .prependTo($self.find('.owl-newnav'));

                $self.find('.owl-nav')
                    .find('.owl-next')
                    .appendTo($self.find('.owl-newnav'));

            }

            var $newnav = $self.find('.owl-newnav');
            if ($self.find('.owl-nav').hasClass('disabled')) {
                $newnav.addClass('nav-disabled');
            } else {
                $newnav.removeClass('nav-disabled');
            }

            if ($self.find('.owl-dots').hasClass('disabled')) {
                $newnav.addClass('dots-disabled');
            } else {
                $newnav.removeClass('dots-disabled');
            }
        });

    }

    /**
     * object-fit polyfill check
     */
    function fitImages() {
        if (typeof objectFitImages == 'function') {
            objectFitImages();
        }
    }

    /**
     * Select2 enable
     */
    function initSelect2() {
        if ($.fn.select2) {
            $('select').each(function () {
                $(this).select2({
                    theme: "bootstrap",
                    containerCssClass: ':all:',
                    placeholder: $(this).data('placeholder'),
                    minimumResultsForSearch: -1,
                });
            });
        }
    }

    /**
     * Smooth scroll links on page
     */
    function dataScroll() {
        $('a[data-scroll]').click(function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') ||
                location.hostname == this.hostname) {

                var target = $(this.hash);
                var offset = $('header.master .bottom').outerHeight() + 30;

                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (typeof $(this).data('offset') !== 'undefined' && $(this).data('offset').length > 0) {
                    offset = $(this).data('offset');
                }

                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - offset
                    }, 1000);
                    return false;
                }
            }
        });
    }

    function deferBackgroundImages() {
        // document.addEventListener("DOMContentLoaded", function () {
        var bgObserver = new IntersectionObserver(function (entries, imgObserver) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var lazy = entry.target;
                    //console.log("lazy loading ", lazy);
                    lazy.style.backgroundImage = "url(" + lazy.getAttribute('data-bg-src') + ")";
                    lazy.removeAttribute('data-bg-src');
                    imgObserver.unobserve(lazy);
                }
            });
        });

        var arr = document.querySelectorAll('[data-bg-src]');
        arr.forEach(function (v) {
            bgObserver.observe(v);
        });

        // });
    }

    function owlStuff() {
        // Owl nav
        var owlResize = debounce(function () {
            owl();
        }, 0);

        $(window).on('resize', owlResize);
        owlResize();
    }

    return {
        init: function () {
            fitImages();
            //initSelect2();
            dataScroll();
            //owlStuff();

            deferBackgroundImages();
        },
        owl: function () {
            owl();
        }
    };
})(window.jQuery, window, document);